import { parser } from '@obvious.tech/constellation-swagger-parser-admin'
import { swaggerfiles } from '@obvious.tech/constellation'
import EntitiesCustomization from './EntitiesCustomization'
import DefinitionsCustomization from './DefinitionsCustomization'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default (API_URL: string) => {
  const parsed = parser({
    baseURL: API_URL,
    swaggerfiles,
  })

  const definitions = DefinitionsCustomization(swaggerfiles)

  return {
    ...parsed,
    definitions: {
      ...definitions,
      entities: EntitiesCustomization(definitions.entities),
    },
  }
}
